export async function update(chatId, { name, observingMessageId, photoUrl }) {
  const response = await this.patch(`/chats/${chatId}/membership`, {
    chat_membership: {
      name,
      observing_message_id: observingMessageId,
      photo_url: photoUrl,
    },
  });

  return response;
}

export async function subscribe(chatId) {
  const response = await this.post(`/chats/${chatId}/membership`);

  return response;
}

export async function unsubscribe(chatId) {
  const response = await this.delete(`/chats/${chatId}/membership`);

  return response;
}
